// @flow
import * as React from 'react';
import styled from 'styled-components';
import LoadingSpinner from 'common/components/LoadingSpinner';
import type { DateRange } from 'statsradio/domain/reach';
import { Card } from 'statsradio/themes/v3/Stylesheet';
import ComparedMetricsOverview from './ComparedMetricsOverview';
import MetricsOverview from './MetricsOverview';

export const LoadingComponent = styled(Card) `
  margin-bottom: ${({ theme }) => theme.V3.metrics.margin.normal}px;
`;

interface Props {
  dateRange: DateRange;
  dateRangeCompared: DateRange | void;
  metrics: {
      totalReach: Object;
      averageTotalReach: Object;
      averageQuarterHourReach: Object;
    } | void
}

export default function MetricsOverviewSection(props: Props) {
  const { dateRange, dateRangeCompared, metrics } = props;
  return (
    <React.Fragment>
      {metrics &&
      <React.Fragment>
        {dateRangeCompared &&
        <ComparedMetricsOverview
          dateRange={dateRange}
          comparedDateRange={dateRangeCompared}
          cumulativeReach={metrics.totalReach}
          averageQuarterHourReach={metrics.averageQuarterHourReach}
        />
        }
        {!dateRangeCompared &&
        <MetricsOverview
          dateRange={dateRange}
          cumulativeReach={metrics.totalReach}
          averageQuarterHourReach={metrics.averageQuarterHourReach}
        />
        }
      </React.Fragment>
      }
      {!metrics &&
      <LoadingComponent>
        <LoadingSpinner size={'large'} />
      </LoadingComponent>
      }
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/v2/components/reachMetricsOverview/MetricsOverviewSection.js